import { Capacitor } from "@capacitor/core";
import { Haptics, ImpactStyle } from "@capacitor/haptics";

export const triggerHaptic = async () => {
  try {
    if (Capacitor.getPlatform() === "web") return;
    await Haptics.impact({ style: ImpactStyle.Heavy });
  } catch {
    // Haptics not available, silently fail.
  }
};
